import header from '../components/rbata.header';
import page from './rbata.page';
import personalizeService from '../services/rbata.personalizeService';
import logger from './rbata.logger';

const tooltip = {
    $cartTooltip:        undefined,
    $userTooltip:        undefined,
    cartTooltipTimer:    undefined,
    userTooltipTimer:    undefined,
    voucherTooltipTimer: undefined,

    showCartTooltip(productName) {
        const newMessage = this.tooltipCartTemplate(this.$cartTooltip.data('msg'), productName);
        tooltip.recalculatePosition();
        this.$cartTooltip.attr('title', newMessage);
        this.$cartTooltip.attr('data-original-title', newMessage);
        this.$cartTooltip.tooltip('update');
        page.addBackdrop(true);
        this.$cartTooltip.tooltip('show');
        this.$body.on('click.cartTooltip', () => {
            clearTimeout(this.cartTooltipTimer);
            this.hideCartTooltip();
        });
        clearTimeout(this.cartTooltipTimer);
        this.cartTooltipTimer = setTimeout(this.hideCartTooltip, 3000);
    },
    showSignUpTooltip() {
        const newMessage = this.tooltipUserTemplate(this.$userTooltip.data('signupMsg'), '', '');
        tooltip.recalculatePosition();
        this.$userTooltip.attr('title', newMessage);
        this.$userTooltip.attr('data-original-title', newMessage);
        this.$userTooltip.tooltip('update');
        this.$userTooltip.tooltip('show');
        this.userTooltipTimer = setTimeout(this.hideUserTooltip, 3000);
    },

    showLoggedInTooltip(userName) {
        const newMessage = this.tooltipUserTemplate(this.$userTooltip.data('loginMsgPre'), userName,
                this.$userTooltip.data('loginMsgPost'));
        tooltip.recalculatePosition();
        this.$userTooltip.attr('title', newMessage);
        this.$userTooltip.attr('data-original-title', newMessage);
        this.$userTooltip.tooltip('update');
        this.$userTooltip.tooltip('show');
        this.voucherTooltipTimer = setTimeout(this.hideUserTooltip, 3000);
    },
    showFormError(msg) {
        tooltip.recalculatePosition();
        this.$formErrorTooltip.attr('title', msg);
        this.$formErrorTooltip.attr('data-original-title', msg);
        this.$formErrorTooltip.tooltip('update');
        this.$formErrorTooltip.tooltip('show');
        this.$body.one('click.formErrorTooltip', () => {
            tooltip.$formErrorTooltip.tooltip('hide');
        });
    },
    voucherAddTooltip(msg, isSuccess) {
        const tooltipContent = this.voucherAppliedTemplate(msg);
        const finalMessage   = isSuccess ? tooltipContent : msg
        tooltip.recalculatePosition();
        this.$voucherTooltip.attr('title', finalMessage);
        this.$voucherTooltip.attr('data-original-title', finalMessage);
        this.$voucherTooltip.tooltip('update');
        this.$voucherTooltip.tooltip('show');
        this.userTooltipTimer = setTimeout(this.hideVoucherTooltip, 3000);
    },
    bindToolTips() {
        this.$body = $('body');
        tooltip.recalculatePosition();
        /**
         * Cache only tooltips in desktop header
         * Utility nav is also in mobile flyout that uses display:none, and script will fail on show
         */
        this.$cartTooltip = $('.js-minicart-tooltip');
        this.$userTooltip      = $('.js-user-status-tooltip');
        this.$formErrorTooltip = $('.js-form-error-tooltip');
        this.$voucherTooltip   = $('.js-add-coupon-tooltip');

        this.$cartTooltip.tooltip({
            html:      true,
            sanitize:  false,
            title:     '',
            placement: 'bottom',
            trigger:   'manual',
            container: '#tooltip-container'
        });

        this.$userTooltip.tooltip({
            html:      true,
            sanitize:  false,
            title:     '',
            placement: 'bottom',
            trigger:   'manual',
            container: '#tooltip-container',
            customClass: 'tooltip-modern'
        });

        this.$voucherTooltip.tooltip({
            html:        true,
            sanitize:    false,
            title:       '',
            placement:   'bottom',
            trigger:     'manual',
            container:   '#tooltip-container',
            customClass: 'tooltip-modern'
        });

        this.$formErrorTooltip.tooltip({
            html:        true,
            sanitize:    false,
            title:       '',
            placement:   'bottom',
            trigger:     'manual',
            container:   '#tooltip-container',
            customClass: 'tooltip--error'
        });
    },
    tooltipCartTemplate(title, productName) {
        return `<svg class="icon">
                    <use xlink:href="#icon-checkmark-v2"></use>
                </svg> ${productName} ${title}`;
    },
    tooltipUserTemplate(preMsg, name, postMsg) {
        return `${preMsg}${name}${postMsg}`;
    },
    voucherAppliedTemplate(msg) {
        const message = msg ? msg.toUpperCase() : '';
        return `<svg class="icon">
            <use xlink:href="#ico-check"></use>
        </svg><span>${message}</span>`;
    },
    hideCartTooltip() {
        page.addBackdrop(false);
        tooltip.$cartTooltip.tooltip('hide');
        tooltip.$body.off('click.cartTooltip');
    },
    hideUserTooltip() {
        tooltip.$userTooltip.tooltip('hide');
    },
    hideVoucherTooltip() {
        tooltip.$voucherTooltip.tooltip('hide');
    },
    showUserTooltips() {
        personalizeService.getPersonalizedData().then((data) => {
            if (data.isRecentlyLoggedIn) {
                tooltip.showLoggedInTooltip(data.customerName);
            } else if (data.isRecentlySignUp) {
                tooltip.showSignUpTooltip();
            }
        }, (jqXHR) => {
            logger.error(`error in tooltip.showUserTooltips, code: ${jqXHR.status}`);
        });
    },

    recalculatePosition() {
        document.documentElement.style.setProperty('--tooltipTopOffset', `${header.$header.innerHeight()}px`);
    }
}

$(() => {
    if ($('body').length) {
        tooltip.bindToolTips();
        tooltip.showUserTooltips();
    }
});

export default tooltip;
